import {
  FormSection,
  HederSection,
  HederText,
  ImagSection,
  LeftSection,
  RightSection,
  Section,
  Image,
  TextEdit,
  FormCus,
  InputContainer,
  ImgEdit,
} from "./StyledEditProfile";
import { ArrowRight } from "../../../images";
import { CircularProgress, IconButton, MenuItem } from "@mui/material";
import { user, edit, editProfile } from "../../../images";
import { useState } from "react";
import {
  DropDown,
  InputFail,
  InputPassword,
  MuiButton,
  PhoneNumInput,
} from "../../../Components/Form";
import { InputText } from "../Auth/StyledAuth";
import { Link, useNavigate } from "react-router-dom";
import { Form, Formik } from "formik";
import { FormattedMessage, useIntl } from "react-intl";
import React from "react";
import Data from "./data";
import { GET_REQUEST, POST_REQUEST } from "../../../HooksApi/useApi";
import UseGetData from "../../../HookAxios/getdata";
import {
  USeInsertData,
  USeInsertDataWithImage,
} from "../../../HookAxios/postData";
import { Fade } from "react-reveal";
import { useDispatch, useSelector } from "react-redux";
import {
  changeDataProfile,
  changeDataPr,
  changeImageUser,
} from "../Auth/features/Auth";
const EditProfile = () => {
  const token = useSelector((state) => state.Auth.userInfo.token);
  const data = useSelector((state) => state.Auth.userInfo.profileData);
  const dataUser = useSelector((state) => state.Auth.userInfo.data.image_path);
  // const navigate = useNavigate();
  const intl = useIntl();
  const { formikProps } = Data();
  const [Imge, setImge] = useState(
    `${process.env.REACT_APP_BASE_URL}${dataUser}`
  );
  const [country, setCountry] = useState("00963");
  const [idLocation, setIdLocation] = useState(data.state_id);
  const [idLocationId, setIdLocationId] = useState(data.location_id);
  const [syria, setSyria] = useState(false);
  const [phone, setPhone] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [Status, setStatus] = useState(false);
  const [ShowPassword, setShowPassword] = useState(false);
  const changeImage = (e) => {
    if (e.target.files && e.target.files[0]) {
      setImge(URL.createObjectURL(e.target.files[0]));
      setSelectedFile(e.target.files[0]);
    }
  };
  const dispatch = useDispatch();
  const {
    mutate: editProfil,
    status: StatusEditProfile,
    data: dataEditProfile,
    error: errorEditProfile,
  } = POST_REQUEST({
    request: (data) =>
      USeInsertData("edit_profile", data, { Authorization: `Bearer ${token}` }),
    handelOnSettledError,
    handelOnSettledData,
  });
  function handelOnSettledError(error) {
    setStatus(false);
    // navigate("/profile");
  }
  function handelOnSettledData(data) {
    dispatch(changeDataPr(data.data.data[0]));
    setStatus(false);
    // navigate("/profile");
  }
  const {
    mutate: addImg,
    status: ImgStatus,
    data: ImgData,
    error: errorData,
  } = POST_REQUEST({
    request: (data) =>
      USeInsertDataWithImage("add_photo ", data, {
        Authorization: `Bearer ${token} `,
      }),
    handelOnSettledError: errorFile,
    handelOnSettledData: SucceedsFile,
  });
  function errorFile(error) {
    setStatus(false);
  }
  function SucceedsFile(data) {
    setStatus(false);
    dispatch(changeImageUser(data.data.image_url));
  }
  const {
    isLoading: GetState,
    data: dataState,
    isError: isErrorState,
    error: errorState,
    isFetching: FitchingState,
    refetch: refetchState,
  } = GET_REQUEST({
    queryKey: "getState",
    request: () => UseGetData("get_state", { code: Number(country) }),
    enabled: false,
  });
  const {
    isLoading: GetLocation,
    data: dataLocation,
    isError: isErrorLocation,
    error: errorLocation,
    isFetching: FitchingLocation,
    refetch: refetchLocation,
  } = GET_REQUEST({
    queryKey: "getLocation",
    request: () => UseGetData("get_locations", { id: idLocation }),
    enabled: false,
  });
  React.useEffect(() => {
    if (Number(country) == "00963") {
      setSyria(true);
      refetchState();
    } else {
      setSyria(false);
    }
  }, [country]);
  React.useEffect(() => {
    if (idLocation !== data.state_id) {
      refetchLocation();
    }
  }, [idLocation]);

  const changeLocation = (id) => {
    setIdLocation(id);
  };
  const changeLocationId = (id) => {
    setIdLocationId(id);
  };
  const onSubmit = (data) => {
    setStatus(true);
    editProfil({
      ...data,
      state: idLocation,
      location: idLocationId,
      phone: phone.slice(4, Number(data.login).length).split(" ").join(""),
      country_code: country,
    });
    if (!selectedFile) return "هذا الحقل مطلوب";
    else {
      const formData = new FormData();
      formData.append("personal_image", selectedFile);
      addImg(formData);
    }
  };
  const getPhone = (phone, country) => {

    setPhone(phone);
    setCountry(`00${country}`);
  };

  return (
    <Section>
      <RightSection>
        <HederSection>
          <IconButton>
            <Link to="/profile">
              <img src={ArrowRight} alt="" />
            </Link>
          </IconButton>
          <HederText>تعديل الحساب</HederText>
        </HederSection>

        <Formik
          initialValues={formikProps.initialValues}
          validationSchema={formikProps.validationSchema}
          onSubmit={onSubmit}
          render={({ handleChange, handleBlur, values, errors, touched }) => (
            <Form style={{ width: "100%", flex: "1" }}>
              <FormSection>
                <ImagSection>
                  <label htmlFor="upload-photo" style={{ cursor: "pointer" }}>
                    <Image src={Imge} />
                    <TextEdit>
                      <img src={edit} alt="" />
                      تغير الصورة
                    </TextEdit>
                  </label>
                  <input
                    type="file"
                    id="upload-photo"
                    onChange={changeImage}
                    style={{ display: "none" }}
                  />
                </ImagSection>
                <FormCus>
                  <InputContainer>
                    <InputText>الاسم الكامل</InputText>
                    <InputFail
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.full_name}
                      error={errors.full_name && touched.full_name}
                      errorText={
                        errors.full_name && touched.full_name
                          ? errors.full_name
                          : null
                      }
                      name="full_name"
                      width="100%"
                      height="40px"
                      placeholder={intl.formatMessage({
                        id: `AuthSignUp.Placeholderfull_name`,
                      })}
                    />
                  </InputContainer>
                  <InputContainer>
                    <InputText>اسم الأب</InputText>
                    <InputFail
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.father_name}
                      error={errors.father_name && touched.father_name}
                      errorText={
                        errors.father_name && touched.father_name
                          ? errors.father_name
                          : null
                      }
                      name="father_name"
                      width="100%"
                      height="40px"
                      placeholder={intl.formatMessage({
                        id: `AuthSignUp.Placeholderfather_name`,
                      })}
                    />
                  </InputContainer>
                  <InputContainer>
                    <InputText>
                      <FormattedMessage id={`AuthSignUp.phone`} />
                    </InputText>
                    {setPhone(values.phone)}

                    <PhoneNumInput
                      onBlur={handleBlur}
                      inputProps={{ name: "phone" }}
                      value={values.phone}
                      onChange={(phoneNumber, country, e) => [
                        handleChange(e),
                        getPhone(
                          Number(
                            phoneNumber.slice(country.dialCode.length)
                          ).toString(),
                          country.dialCode
                        ),
                      ]}
                      error={errors.phone && touched.phone}
                      errorText={
                        errors.phone && touched.phone ? errors.phone : null
                      }
                      name="phone"
                      width="100%"
                      height="40px"
                      placeholder={intl.formatMessage({
                        id: `AuthSignUp.Placeholderphone`,
                      })}
                    />
                  </InputContainer>
                  {syria ? (
                    <>
                      <InputContainer>
                        <InputText>المحافظة</InputText>
                        <DropDown
                          onChange={(e) => [
                            handleChange(e),
                            changeLocation(e.target.value),
                          ]}
                          onBlur={handleBlur}
                          value={values.state}
                          error={errors.state && touched.state}
                          errorText={
                            errors.state && touched.state ? errors.state : null
                          }
                          name="state"
                          width="100%"
                          height="40px"
                          placeholder={intl.formatMessage({
                            id: `AuthSignUp.PlaceholderState`,
                          })}
                        >
                          {idLocation !== data.state_id ? null : (
                            <MenuItem value={values.state}>
                              {values.state}{" "}
                            </MenuItem>
                          )}
                          {!GetState && dataState
                            ? dataState?.data?.State.map((country) => (
                              <MenuItem key={country.id} value={country.id}>
                                {country.name}{" "}
                              </MenuItem>
                            ))
                            : null}
                        </DropDown>
                      </InputContainer>
                      <InputContainer>
                        <InputText>المدينة</InputText>
                        <DropDown
                          onChange={(e) => [
                            handleChange(e),
                            changeLocationId(e.target.value),
                          ]}
                          onBlur={handleBlur}
                          value={values.location}
                          error={errors.location && touched.location}
                          errorText={
                            errors.location && touched.location
                              ? errors.location
                              : null
                          }
                          name="location"
                          width="100%"
                          height="40px"
                          placeholder={intl.formatMessage({
                            id: `AuthSignUp.Placeholdercity`,
                          })}
                        >
                          {idLocation !== data.state_id ? null : (
                            <MenuItem value={values.location}>
                              {values.location}{" "}
                            </MenuItem>
                          )}

                          {dataLocation
                            ? dataLocation?.data.Locations.map((country) => (
                              <MenuItem key={country.id} value={country.id}>
                                {country.name}{" "}
                              </MenuItem>
                            ))
                            : null}
                        </DropDown>
                      </InputContainer>
                    </>
                  ) : null}

                  <InputContainer>
                    <InputText>البريد الإلكتروني</InputText>
                    <InputFail
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                      error={errors.email && touched.email}
                      errorText={
                        errors.email && touched.email ? errors.email : null
                      }
                      name="email"
                      width="100%"
                      height="40px"
                      placeholder="أدخل بريدك هنا"
                    />
                  </InputContainer>
                  {ShowPassword ? (
                    <Fade>
                      <InputContainer>
                        <InputText>كلمة المرور</InputText>
                        <InputFail
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.password}
                          error={errors.password && touched.password}
                          errorText={
                            errors.password && touched.password
                              ? errors.password
                              : null
                          }
                          name="password"
                          width="100%"
                          height="40px"
                          placeholder="ادخل كلمة المرور لحفظ التغيرات"
                        />
                      </InputContainer>
                    </Fade>
                  ) : null}
                  <InputContainer style={{ marginTop: "16px" }}>
                    {ShowPassword ? (
                      Status ? (
                        <CircularProgress sx={{ alignSelf: "center" }} />
                      ) : (
                        <MuiButton width="100%" height="40px" text="حفظ" />
                      )
                    ) : (
                      <MuiButton
                        width="100%"
                        height="40px"
                        text="التالي"
                        type="button"
                        onClick={() => setShowPassword(true)}
                      />
                    )}
                  </InputContainer>
                </FormCus>
              </FormSection>
            </Form>
          )}
        />
      </RightSection>
      <LeftSection>
        <ImgEdit src={editProfile} />
      </LeftSection>
    </Section>
  );
};

export default EditProfile;
